import axios from 'axios';
// config

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: 'https://maherha.com/api/v1/',
});
axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axiosInstance.defaults.headers.common['Access-Control-Allow-Headers'] = '*';

axiosInstance.defaults.headers.common['Content-Type'] = 'application/json;';

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject((error.response && error.response.data) || 'خطایی پیش آمد')
);

export default axiosInstance;
